<template>
    <div class="spcialBox text-center" v-if="this.response">
        <!-- <span class="feedPoint">{{ `% ${Math.floor(this.response.feed_ratio * 100)}` }}</span> -->
        <div>
            <span>{{ this.response.image_base64 }}</span>
        </div>
        <div class="imgBox">
            <img :src="`data:image/png;base64,${this.response}`" />
        </div>
    </div>
</template>

<style>
.spcialBox {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    /* height: 500px; */
}

.spcialBox .imgBox {
    width: 100%;
    /* height: 500px; */
}

.spcialBox img {
    object-fit: contain;
    height: 100%;
    width: 100%;
}
</style>

<script>
/* eslint-disable */

export default {
    name: 'homePage',
    emits: ['breadcrumb'],
    components: {},
    data() {
        return {
            response: null,
        }
    },
    methods: {
    },
    async mounted() {
        this.$emit('breadcrumb', [this.$t('nav.tourMonitor')])
        let data = await this.$axios.get({ uri: '/last_img' })
        this.response = data
        setInterval(async () => {
            this.response = await this.$axios.get({ uri: '/last_img' })
        }, 5 * 1000);
    },
    computed: {}
}
</script>
